import classNames from 'classnames';
import { forwardRef, InputHTMLAttributes, ReactNode, useEffect } from 'react';

import { Icon, Typography } from '../';

import './Checkbox.scss';

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
  indeterminate?: boolean;
  innerRef?: React.RefObject<HTMLInputElement>;
  errorMessage?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { innerRef, label, checked, disabled, className, indeterminate, onChange, errorMessage, ...props },
  ref,
) {
  useEffect(() => {
    if ((checked === null || checked === undefined) && onChange) {
      onChange({ target: { checked: props.defaultChecked ?? false } } as React.ChangeEvent<HTMLInputElement>);
    }
  }, []);

  return (
    <div className="custom-checkbox-wrapper">
      <label
        className={classNames('custom-checkbox', className, {
          'custom-checkbox--checked': checked,
          'custom-checkbox--disabled': disabled,
          'custom-checkbox--checked-indeterminate': indeterminate,
          'custom-checkbox--disabled-indeterminate': indeterminate && disabled,
        })}
      >
        <input
          {...props}
          ref={ref ?? innerRef}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          className="custom-checkbox__input"
        />
        <div className="custom-checkbox__checkmark">
          {checked && !indeterminate && <Icon name="check" />}
          {disabled && !indeterminate && !checked && <Icon name="close" />}
        </div>
        {label && <Typography as="span">{label}</Typography>}
      </label>
      {errorMessage && (
        <Typography variant="TEXT14" color="red" semibold className="custom-form-input__error">
          {errorMessage}
        </Typography>
      )}
    </div>
  );
});
